module.exports = __webpack_public_path__ + "static/media/mobile-marketing.48f41bbc.svg";